import React from "react";
import { Form, Button } from "react-bootstrap";
// import Select from "react-select";
// import { FaUpload, FaImage, FaBook } from "react-icons/fa";
import {
  SocialMediaOption,
  HashtagCountOption,
  WritingToneOption,
  MAX_FILE_SIZE,
  ALLOWED_FILE_TYPES,
} from "./types";
import {
  socialMediaOptions,
  hashtagCountOptions,
  writingToneOptions,
} from "./constants";

interface HashtagFormProps {
  image: File | undefined;
  setImage: (file: File | undefined) => void;
  topic: string;
  setTopic: (topic: string) => void;
  language: string;
  setLanguage: (language: string) => void;
  platform: SocialMediaOption | null;
  setPlatform: (option: SocialMediaOption | null) => void;
  hashtagCount: HashtagCountOption | null;
  setHashtagCount: (option: HashtagCountOption | null) => void;
  format: string;
  setFormat: (format: string) => void;
  writingTone: string;
  setWritingTone: (tone: string) => void;
  captionValue: number;
  setCaptionValue: (tone: number) => void;
  handleGenerate: () => void;
  handleExportResults: () => void;
  loading: boolean;
}

const HashtagForm: React.FC<HashtagFormProps> = ({
  image,
  setImage,
  topic,
  setTopic,
  language,
  setLanguage,
  platform,
  setPlatform,
  hashtagCount,
  setHashtagCount,
  format,
  setFormat,
  writingTone,
  setWritingTone,
  captionValue,
  setCaptionValue,
  handleGenerate,
  handleExportResults,
  loading,
}) => {
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        alert(`Only ${ALLOWED_FILE_TYPES.join(", ")} files are allowed.`);
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        alert(
          `File size must be less than ${MAX_FILE_SIZE / (1024 * 1024)}MB.`
        );
        return;
      }
      setImage(file);
    }
  };

  const handleTopicChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTopic(event.target.value);
  };

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setLanguage(event.target.value);
  };

  const handlePlatformChange = (selectedOption: SocialMediaOption | null) => {
    setPlatform(selectedOption);
  };

  const handleHashtagCountChange = (
    selectedOption: HashtagCountOption | null
  ) => {
    setHashtagCount(selectedOption);
  };

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormat(event.target.value);
  };

  const handleWritingToneChange = (
    selectedOption: WritingToneOption | null
  ) => {
    setWritingTone(selectedOption?.value || "Formal");
  };

  return (
    <div
      className="border rounded formClassMain"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="flex-grow-1 pe-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          {/* <h5 className="fw-bold">
            Generate hashtags and Caption for this topic...
          </h5> */}
          <Form.Select
            value={language}
            onChange={handleLanguageChange}
            style={{ width: "150px" }}
          >
            <option>English</option>
            <option>Spanish</option>
            <option>French</option>
            <option>German</option>
          </Form.Select>
        </div>
        {/* <div className="mb-3">
          <div className="border p-3 text-center rounded" style={{ backgroundColor: "#ffffff", cursor: "pointer" }}>
            <label htmlFor="imageUpload" className="d-block">
              <FaUpload size={20} className="me-2" />
              Drop your image here, or <span className="text-primary">select one</span>
            </label>
            <p className="small text-muted mb-0">JPG, PNG, GIF files less than 10MB</p>
            <input
              type="file"
              id="imageUpload"
              accept={ALLOWED_FILE_TYPES.join(",")}
              onChange={handleImageChange}
              hidden
            />
          </div>
          {image && (
            <div className="mt-2 text-center">
              <FaImage size={20} className="me-2 text-success" />
              <span>{image.name}</span>
            </div>
          )}
        </div> */}
        <Form.Group controlId="topicInput">
          <Form.Control
            as="textarea"
            rows={8}
            value={topic}
            onChange={handleTopicChange}
            placeholder="e.g. Tips for a productive morning routine"
            style={{
              borderColor: "#8CC540",
              borderWidth: "2px",
              paddingTop: "13px",
            }}
          />
        </Form.Group>
        <div className="formBottomHashtag">
          <Form.Group controlId="writingTone" className="captionStyleCss">
            <Form.Label className="fw-bold">Writing Tone</Form.Label>
            <Form.Select
              value={writingTone || ""}
              className="selectWritingTone"
              onChange={(e) => {
                setWritingTone(e.target.value || "Formal");
                // const val = languageOptions.find(
                //   (x) => x.value === e.target.value
                // );
                // val && onLanguageChange(val);
              }}
            >
              {writingToneOptions.map((x, i) => (
                <option value={x.value} key={i}>
                  <div>{x.label}</div>
                </option>
              ))}
            </Form.Select>
            {/* <Select<WritingToneOption>
              options={writingToneOptions}
              value={writingToneOptions.find(
                (option) => option.value === writingTone
              )}
              onChange={handleWritingToneChange}
              className="basic-single"
              classNamePrefix="select"
              styles={{
                container: (provided) => ({ ...provided, width: "200px" }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
              menuPlacement="auto"
            /> */}
          </Form.Group>
          <Form.Group controlId="writingTone" className="captionStyleCss">
            <Form.Label className="fw-bold">Captions</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter number"
              value={captionValue}
              onChange={(e: any) => {
                const value = Number(e.target.value);

                if (isNaN(value) || value < 1) {
                  setCaptionValue(1);
                } else {
                  setCaptionValue(Math.min(10, value));
                }
              }}
            />
          </Form.Group>
          <Button
            variant="warning"
            onClick={handleGenerate}
            disabled={loading}
            className="generatingButton991"
          // style={{
          //   backgroundColor: "#8CC540",
          //   borderColor: "#8CC540",
          //   color: "white",
          //   marginLeft: "auto",
          //   minWidth: "17rem",
          // }}
          >
            {loading ? "Generating..." : "✨ Generate Captions & Hashtags"}
          </Button>
        </div>
      </div>
      <div
        className="secondFormHashForm bg-light"
      // style={{ minWidth: "250px" }}
      >
        <Form.Group controlId="platformSelect" className="mb-3">
          <Form.Label className="fw-bold">Social media</Form.Label>
          <Form.Select
            value={platform?.value || ""}
            onChange={(e) => {
              const val = socialMediaOptions.find(
                (x) => x.value === e.target.value
              );
              val && setPlatform(val);
            }}
          >
            {socialMediaOptions.map((x, i) => (
              <option value={x.value} key={i}>
                <div>{x.label}</div>
              </option>
            ))}
          </Form.Select>
          {/* <Select<SocialMediaOption>
            options={socialMediaOptions}
            value={platform}
            onChange={handlePlatformChange}
            styles={{
              container: (base) => ({ ...base, width: "100%" }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            menuPlacement="auto"
          /> */}
        </Form.Group>
        <Form.Group controlId="hashtagCountSelect" className="mb-3">
          <Form.Label className="fw-bold">Generate</Form.Label>
          <Form.Select
            value={hashtagCount?.value || ""}
            onChange={(e) => {
              const val = hashtagCountOptions.find(
                (x) => x.value.toString() === e.target.value
              );
              val && setHashtagCount(val);
            }}
          >
            {hashtagCountOptions.map((x, i) => (
              <option value={x.value} key={i}>
                <div>{x.label}</div>
              </option>
            ))}
          </Form.Select>
          {/* <Select<HashtagCountOption>
            options={hashtagCountOptions}
            value={hashtagCount}
            onChange={handleHashtagCountChange}
            styles={{
              container: (base) => ({ ...base, width: "100%" }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            menuPlacement="auto"
          /> */}
        </Form.Group>
        <Form.Group controlId="formatSelect" className="mb-3">
          <Form.Label className="fw-bold">Format as</Form.Label>
          <div className="format-radio-wrapper">
            <Form.Check
              type="radio"
              id="numberedList"
              label="Numbered list"
              name="format"
              value="Numbered list"
              checked={format === "Numbered list"}
              onChange={handleFormatChange}
              className="mb-2"
            />
            <Form.Check
              type="radio"
              id="oneLine"
              label="One line"
              name="format"
              value="One line"
              checked={format === "One line"}
              onChange={handleFormatChange}
            />
          </div>
        </Form.Group>
        <Button
          variant="warning"
          onClick={handleGenerate}
          disabled={loading}
          className="generatingButton320"
        // style={{
        //   backgroundColor: "#8CC540",
        //   borderColor: "#8CC540",
        //   color: "white",
        //   marginLeft: "auto",
        //   minWidth: "17rem",
        // }}
        >
          {loading ? "Generating..." : "✨ Generate Caption & Hashtags"}
        </Button>
        <Button
          variant="outline-secondary"
          className="w-100 mt-3"
          onClick={handleExportResults}
        >
          📤 Export Results
        </Button>
      </div>
    </div>
  );
};

export default HashtagForm;
